<ion-content class="ion-padding">
    <div class="max-page-width" [ngClass]="{ 'TriggerPrinting': isPrinting }">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ 'calibration.fullReport' | translate }} - {{ report?.cycle.name }}
            </ion-label>

            <ion-button mode="ios" color="primary" slot="end" *ngIf="nineboxEnabled && !disableBookButton" (click)="getTeamComparisonExcel()">
                {{ 'managerEvaluation.getBookReport' | translate }}
            </ion-button>
            <ion-button mode="ios" color="primary" slot="end" (click)="print()" [disabled]="!report">
                {{ 'generic.print' | translate }}
            </ion-button>
        </ion-item>

        <ng-container *ngIf="report && showData">
            <div id="PrintingHeader">
                <ion-grid class="header">
                    <ion-row>
                        <ion-col class="user" size="3">
                            <img [src]="getImageUrl(report.user.imageUrl)" default="" />
                            <p>
                                {{ report.user.name }}
                            </p>
                        </ion-col>
                        <ion-col [size]="!hideEvolutionOfEvaluationAndRankFromFinalReport ? 6 : 9">
                            <ion-grid>
                                <ion-row>
                                    <ion-col size="4">
                                        <span>{{ 'generic.group' | translate }}:</span>
                                    </ion-col>
                                    <ion-col size="4">
                                        <span>{{ 'cycleParticipants.location' | translate }}</span>
                                    </ion-col>
                                    <ion-col size="4">
                                        <span>{{ 'dashboard.lineManager' | translate }}</span>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="4">
                                        {{ report.user.group || '--' }}
                                    </ion-col>
                                    <ion-col size="4">
                                        {{ report.user.location || '--' }}
                                    </ion-col>
                                    <ion-col size="4">
                                        <img class="manager" [src]="getImageUrl(report.lineManager.imageUrl)"
                                            default="" /> {{ report.lineManager.name }}
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="4">
                                        <span>{{ 'cycleParticipants.businessUnit' | translate }}:</span>
                                    </ion-col>
                                    <ion-col size="4">
                                        <span>{{ 'generic.serviceDate' | translate }}</span>
                                    </ion-col>
                                    <ion-col size="4">
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="4">
                                        {{ report.user.unit || '--' }}
                                    </ion-col>
                                    <ion-col size="4">
                                        {{ serviceDate }}
                                    </ion-col>
                                    <ion-col size="4">
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="4">
                                        <span>
                                            {{ 'cycleParticipants.segment' | translate }}:
                                        </span>
                                    </ion-col>
                                    <ion-col size="4">
                                        <span *ngIf="!hideHireDate">{{ 'generic.hireDate' | translate }}</span>
                                    </ion-col>
                                    <ion-col size="4" *ngIf="hideHireDate">
                                    </ion-col>
                                    <ion-col size="4">
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col size="4">
                                        {{ report.user.segment || '--' }}
                                    </ion-col>
                                    <ion-col size="4" *ngIf="!hideHireDate">
                                        {{ hireDate }}
                                    </ion-col>
                                    <ion-col size="4" *ngIf="hideHireDate">
                                    </ion-col>
                                    <ion-col size="4">
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-col>
                        <ion-col *ngIf="!hideEvolutionOfEvaluationAndRankFromFinalReport" class="table" size="3">
                            <ion-grid>
                                <ion-row>
                                    <ion-col></ion-col>
                                    <ion-col *ngFor="let year of previousYears">
                                        {{ year }}
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        {{ 'generic.evaluation' | translate }}
                                    </ion-col>
                                    <ion-col *ngFor="let year of previousYears">
                                        {{ getPreviousYearStat(year, 'evaluation') }}
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        {{ 'cycleParticipants.rank' | translate }}
                                    </ion-col>
                                    <ion-col *ngFor="let year of previousYears">
                                        {{ getPreviousYearStat(year, 'rank') }}
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
            <br>
            <div id="FreeEvalMid" *ngIf="!hideOwnValuations && freeEvalMidYearProcessConfig && report.freeEvaluationsEndYear.length > 0">
                <app-free-evaluation-report titleKey="performanceCycle.freeEvalMidYear"
                    [processConfig]="freeEvalMidYearProcessConfig" [evaluations]="report.freeEvaluationsMidYear"
                    [showMoreLess]="false"></app-free-evaluation-report>
            </div>
            <ng-container *ngIf="twoPlusTwoProcessConfig && !twoPlusTwoProcessConfig.hideOnFinalReport">
                <br>
                <div id="CoachReport">
                    <app-coaching-report [report]="report"></app-coaching-report>
                </div>
            </ng-container>
            <br>
            <div id="Report360" *ngIf="!hideOwnValuations && threeSixtyProcessConfig">
                <ng-container *ngIf="!divide360UsersLitByAreaEnabled">
                    <app-360-evaluation-report [processConfig]="threeSixtyProcessConfig"
                        [evaluations]="report.threeSixtyEvaluations" [showMoreLess]="false"></app-360-evaluation-report>
                </ng-container>
                <ng-container *ngIf="divide360UsersLitByAreaEnabled">
                    <div class="container-evaluations" *ngFor="let area of areas">
                        <app-360-evaluation-report [titleKey]="getText(area.globalizationConfig, 'title')"
                            [processConfig]="threeSixtyProcessConfig" [evaluations]="evaluationByArea[area.id]"
                            [showMoreLess]="true"></app-360-evaluation-report>
                    </div>
                </ng-container>
            </div>
            <br>
            <div id="FreeEvalEnd" *ngIf="!hideOwnValuations && freeEvalEndYearProcessConfig && report.freeEvaluationsEndYear.length > 0">
                <app-free-evaluation-report titleKey="performanceCycle.freeEvalEndYear"
                    [processConfig]="freeEvalEndYearProcessConfig" [evaluations]="report.freeEvaluationsEndYear"
                    [showMoreLess]="false"></app-free-evaluation-report>
            </div>
            <br>
            <div id="SelfManager" *ngIf="managerProcessConfig">
                <app-self-manager-evaluation-report [report]="report"></app-self-manager-evaluation-report>
            </div>
        </ng-container>
    </div>
</ion-content>